import { render } from "./AdoptPage.vue?vue&type=template&id=efc1ddc0"
import script from "./AdoptPage.vue?vue&type=script&lang=js"
export * from "./AdoptPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/user_ui/taichung_citizen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__